import { render, staticRenderFns } from "./OverviewComparisonPlaceholder.vue?vue&type=template&id=6a6a82e6&scoped=true&functional=true"
import script from "./OverviewComparisonPlaceholder.vue?vue&type=script&lang=js"
export * from "./OverviewComparisonPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./OverviewComparisonPlaceholder.vue?vue&type=style&index=0&id=6a6a82e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6a6a82e6",
  null
  
)

export default component.exports